/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 设置部分任务延时处理
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  listenerDelayDto: good.ListenerDelayDto,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "put",
    url: `/good/event-delay`,
    data: listenerDelayDto,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
